module.exports = __webpack_public_path__ + "img/3.fc2f3699.png";